import { TAG_STYLE, IFunctionalTagOption } from 'transfix-ui'

export const AWARD_TYPE_OPTIONS = [
  {
    label: 'Primary',
    value: 'primary',
  },
  {
    label: 'Backup',
    value: 'backup',
  },
  {
    label: 'Published',
    value: 'published',
  },
]

export const RATE_TYPE_OPTIONS = [
  {
    label: 'RPM',
    value: 'contract_rpm',
  },
  {
    label: 'Linehaul',
    value: 'contract_linehaul',
  },
  {
    label: 'All-in',
    value: 'contract_all_in',
  },
]

export const VOLUME_TYPE_OPTIONS = [
  {
    label: 'Gross',
    value: 'gross',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Quarterly',
    value: 'quarterly',
  },
  {
    label: 'Annual',
    value: 'annual',
  },
]

export const jobStatusOptions: IFunctionalTagOption[] = [
  {
    label: 'Deving',
    value: 'deving',
    style: TAG_STYLE.info,
  },
  {
    label: 'Done',
    value: 'done',
    style: TAG_STYLE.success,
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
    style: TAG_STYLE.error,
  },
  {
    label: 'Pending Volume',
    value: 'pending_volume',
    style: TAG_STYLE.warning,
  },
  {
    label: 'Redev',
    value: 'redev',
    style: TAG_STYLE.dark,
  },
]

export const jobStatusMultiSelectOptions = (selectedOptions?: string[]) =>
  jobStatusOptions.map(option => {
    const selected = !!selectedOptions?.includes(option.value)
    return {
      ...option,
      selected,
    }
  })

export const dropTypeOptions: IFunctionalTagOption[] = [
  {
    label: 'Drop',
    value: 'drop',
  },
  {
    label: 'Live',
    value: 'live',
  },
]

export const dropTypeMultiSelectOptions = dropTypeOptions.map(option => ({
  ...option,
  selected: false,
}))

export const confirmedOptions: IFunctionalTagOption[] = [
  {
    label: 'Yes',
    value: 'yes',
    style: TAG_STYLE.success,
  },
  {
    label: 'No',
    value: 'no',
    style: TAG_STYLE.info,
  },
]
